const urlParams = new URLSearchParams(window.location.search);
const isDebug = urlParams.get('debug') === 'true';

export const debugLog = (...args) => {
    if (isDebug) {
        console.log('[DEBUG]', ...args);
    }
};

export { isDebug };
